@import './bq-status.variables';

.bq-status__circle {
  &::part(base) {
    --bq-badge--size-medium: var(--bq-status-circle--size);
  }

  &.success::part(base) {
    --bq-badge--background-color: theme(backgroundColor.ui.success);
  }

  &.danger::part(base) {
    --bq-badge--background-color: theme(backgroundColor.ui.danger);
  }

  &.neutral::part(base) {
    --bq-badge--background-color: theme(backgroundColor.ui.secondary);
  }

  &.alert::part(base) {
    --bq-badge--background-color: theme(backgroundColor.ui.warning);
  }

  &.info::part(base) {
    --bq-badge--background-color: theme(backgroundColor.ui.brand);
  }
}

.bq-status__text ::slotted(*) {
  @apply text-s font-medium leading-regular text-primary p-b-0 p-i-0 m-b-0 m-i-0;
}
